import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center" }

import { onBeforeUnmount, onMounted, ref, computed, watch } from 'vue'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ProgressCircle',
  props: {
    value: { default: 75 },
    size: { default: 100 },
    width: { default: 15 },
    color: { default: 'teal' },
    rotate: { default: 360 },
    autoColor: { type: Boolean, default: true },
    animateOnMount: { type: Boolean, default: true },
    duration: { default: 800 }
  },
  setup(__props: any) {

  const props = __props

  const displayValue = ref<number>(0)

  let interval: number | undefined
  let rafId: number | undefined

  // Não arredonda para inteiro: preserva consumos pequenos (ex.: 0.01%),
  // que de outra forma apareceriam como 0%.
  const clampPercent = (v: number) => Math.max(0, Math.min(100, v))

  const cancelAnim = () => {
    if (rafId) cancelAnimationFrame(rafId)
    rafId = undefined
  }

  const animateTo = (target: number, duration = Math.max(0, props.duration)) => {
    cancelAnim()
    const start = performance.now()
    const from = displayValue.value
    const delta = clampPercent(target) - from

    if (duration === 0 || delta === 0) {
      displayValue.value = clampPercent(target)
      return
    }

    const tick = (now: number) => {
      const elapsed = now - start
      const t = Math.min(1, elapsed / duration)
      // linear easing
      displayValue.value = clampPercent(from + delta * t)
      if (t < 1) {
        rafId = requestAnimationFrame(tick)
      }
    }
    rafId = requestAnimationFrame(tick)
  }

  onMounted(() => {
    // If value is explicitly provided, render static value and do not animate
    if (props.value !== undefined && props.value !== null) {
      const target = clampPercent(props.value)

      if (!props.animateOnMount) {
        displayValue.value = target
        return
      }
      displayValue.value = 0
      animateTo(target)
      return
    }

    // Legacy animated behavior (kept for compatibility)
    displayValue.value = 0
    interval = window.setInterval(() => {
      if (displayValue.value >= 100) {
        displayValue.value = 0
      } else {
        displayValue.value += 10
      }
    }, 1000)
  })

  onBeforeUnmount(() => {
    if (interval) clearInterval(interval)
    if (rafId) cancelAnimationFrame(rafId)
  })

  const size = computed(() => props.size)
  const width = computed(() => props.width)
  const rotate = computed(() => props.rotate)

  // Rótulo exibido no centro: inteiro para valores >= 1%, mas até 2 casas
  // decimais para consumos fracionários pequenos (ex.: 0.01%).
  const formattedValue = computed(() => {
    const v = displayValue.value
    if (v > 0 && v < 1) return parseFloat(v.toFixed(2)).toString()
    return Math.round(v).toString()
  })

  // Compute color based on percentage when autoColor is enabled
  const computedColor = computed(() => {
    if (!props.autoColor) return props.color
    const v = displayValue.value
    if (v < 60) return 'success' // green
    if (v < 85) return 'warning' // amber
    return 'error' // red
  })

  // React to prop changes and animate from current value to new target
  watch(
    () => props.value,
    (nv) => {
      if (nv === undefined || nv === null) return
      const target = clampPercent(nv)
      animateTo(target)
    }
  )

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_progress_circular, {
      "model-value": displayValue.value,
      rotate: rotate.value,
      size: size.value,
      width: width.value,
      color: computedColor.value
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(formattedValue.value) + " % ", 1)
      ]),
      _: 1
    }, 8, ["model-value", "rotate", "size", "width", "color"])
  ]))
}
}

})